// extracted by mini-css-extract-plugin
module.exports = {"galleryContainer":"DrupalGalleryNugget__galleryContainer___1G0Sz","loadingOverlay":"DrupalGalleryNugget__loadingOverlay___21C-v","spinner":"DrupalGalleryNugget__spinner___2klVd"};